import {Editor} from '@tinymce/tinymce-react';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Headers from '../../Components/Header/Headers';
import './headerandfooter.scss';
// import React, { useState } from 'react';
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {useDispatch, useSelector} from 'react-redux';
import Swal from 'sweetalert2';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {setEmptyTemplateEdit} from '../../Redux/Slice/rootSlice';
import {postPrescriptionTemplate, putPrescriptionTemplate} from '../../Redux/Thunk/Actions';

// import SCEditorComponent from '../../Components/SCEditorComponent';

const CONSULTANT_OPTIONS = ['Dr. Aishwarya Parthasarathy', 'Dr. Ashok Kumar', 'Dr. Balamurugan'];

const EmptyTemplate = props => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [editorData, setEditorData] = useState('');
  const patientId = useSelector(state => state.counter.patientid);
  const prescriptionId = useSelector(state => state.counter.prescriptionId);
  const emptyTemplateHtml = useSelector(state => state.counter.emptyTemplateHtml);
  const emptyTemplateEdit = useSelector(state => state.counter.emptyTemplateEdit);
  const templateName = useSelector(state => state.counter.templateName);
  const initialTemplateValue = `<section><div class="patient" style="border: 1px solid black; border-radius: 10px; margin-bottom: 10px;"><div class="nameToAgeContainer" style="display: flex; margin-bottom: 10px; flex-wrap: wrap;"><section style="margin: 0px 10px 10px; display: flex;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">Patient Name :</label><span>${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}</span></section><section style="margin: 0px 10px 10px; display: flex;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">Patient ID :</label><span>${props.patientsData.p_uhid}</span></section><section style="margin: 0px 10px 10px; display: flex;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">Gender :</label><span>${props.patientsData.gender}</span></section><section style="margin: 0px 10px 10px; display: flex;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">Age :</label><span>${props.patientsData.age}</span></section></div></div><div class="vitals-block" style="border: 1px solid black; border-radius: 10px; margin-bottom: 10px; padding: 12px 10px;"><div style="display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px 18px;"><section style="display: flex; align-items: center;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">Bp-</label><span>&nbsp;</span></section><section style="display: flex; align-items: center;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">Ht-</label><span>&nbsp;</span></section><section style="display: flex; align-items: center;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">Wt-</label><span>&nbsp;</span></section><section style="display: flex; align-items: center;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">Spo2-</label><span>&nbsp;</span></section><section style="display: flex; align-items: center;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">BMI-</label><span>&nbsp;</span></section><section style="display: flex; align-items: center;"><label style="font-weight: 600; margin-right: 5px; width: max-content;">PR-</label><span>&nbsp;</span></section></div></div><p></p></section>`;
  const [editorValue, setEditorValue] = useState(initialTemplateValue);
  const [selectedConsultant, setSelectedConsultant] = useState('');
  const [otherConsultantName, setOtherConsultantName] = useState('');
  var listToSplit = emptyTemplateHtml.split(`<p class="Dani"></p>`).length == 1 ? [1, emptyTemplateHtml] : emptyTemplateHtml.split(`<p class="Dani"></p>`);

  const handleEditorChange = value => {
    setEditorValue(value);
  };

  const handlesubmit = () => {
    try {
      (async () => {
        const htmlPayload = document.getElementById('mainEmptyPage1').innerHTML;

        const payload = {
          payload: {
            prescription_template: htmlPayload,
            patient_id: patientId,
            description: '',
            template_type: 'Prescription'
          },
          prescriptionId: prescriptionId
        };

        const patentDetails = emptyTemplateEdit ? putPrescriptionTemplate(payload) : postPrescriptionTemplate(payload);
        dispatch(setEmptyTemplateEdit(false));
        const response = await dispatch(patentDetails);
        if (response?.payload?.status?.code === 200) {
          navigate('/PatientView');
          Swal.fire({
            title: 'Successful.',
            text: 'Record added successful.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        }
      })();
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <>
      <div
        id='mainEmptyPage'
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}>
        <div className='emptyContainer'>
          <header>
            <Headers />
          </header>

          <span className='middleInput'>
            <div style={{marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '10px'}}>
              <label htmlFor='consultantName' style={{fontWeight: 600}}>
                Consultant
              </label>
              <select
                id='consultantName'
                value={selectedConsultant}
                onChange={e => setSelectedConsultant(e.target.value)}
                style={{minWidth: '220px', height: '36px', padding: '0 10px', borderRadius: '6px', border: '1px solid #c9c9c9'}}>
                <option value=''>Select Consultant</option>
                {CONSULTANT_OPTIONS.map(consultant => (
                  <option key={consultant} value={consultant}>
                    {consultant}
                  </option>
                ))}
                <option value='Others'>Others</option>
              </select>
              {selectedConsultant === 'Others' && (
                <input
                  type='text'
                  value={otherConsultantName}
                  onChange={e => setOtherConsultantName(e.target.value)}
                  placeholder='Enter consultant name'
                  style={{minWidth: '220px', height: '36px', padding: '0 10px', borderRadius: '6px', border: '1px solid #c9c9c9'}}
                />
              )}
            </div>
            <Editor
              apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
              initialValue={initialTemplateValue}
              init={{
                height: '800px',
                width: '1200px',
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                  'table'
                ],
                toolbar: 'table'
              }}
              onEditorChange={handleEditorChange}
            />
          </span>

          <footer>{/* <Footer /> */}</footer>
        </div>
      </div>
      <button onClick={handlesubmit} style={{width: '100px'}} className='Button_Create'>
        Save
      </button>

      {/* //*----------------------------------------------------------------------------- */}
      <div
        id='mainEmptyPage1'
        style={{
          // display: "flex",
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}>
        <div className='emptyContainer1'>
          <table>
            <thead>
              <tr>
                <td>
                  <div id='header' class='header1'>
                    <Headers />
                  </div>
                </td>
              </tr>
            </thead>
            <tbody id='samplenew' style={{backgroundColor: 'transparent'}}>
              <tr>
                <td style={{backgroundColor: 'transparent', border: 'none'}}>
                  <div class='content1'>
                    <span>
                      <p class='Dani'></p>
                        <div className='middleSpan1' style={{backgroundColor: 'transparent'}} dangerouslySetInnerHTML={{__html: editorValue}}></div>
                      {(selectedConsultant && selectedConsultant !== 'Others' ? selectedConsultant : otherConsultantName) && (
                        <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '32px'}}>
                          <div style={{minWidth: '220px', textAlign: 'center'}}>
                            <div style={{fontWeight: 600}}>{selectedConsultant === 'Others' ? otherConsultantName : selectedConsultant}</div>
                            <div style={{marginTop: '4px'}}>Consultant</div>
                          </div>
                        </div>
                      )}
                      <p class='Dani'></p>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <div id='footer' class='footer1'>
                    <PrescriptionFooter />
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
};

export default EmptyTemplate;
